export default __webpack_public_path__ + "bfa75c137ef877fba889927d1b4dd8c7.svg";